import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Button, ProgressBar } from "react-bootstrap";
import { XLg } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { TooltipRenderProps } from "react-joyride";
import { resetWhiteLabelJR } from "../../../../helpers";
import {
  whiteLabelJRStep,
  whiteLabelValidJRSteps,
} from "../../../../qraphql/globalVar/state";

export const CustomTooltip = ({
  index,
  step,
  size,
  tooltipProps,
  skipProps,
}: TooltipRenderProps) => {
  const { t } = useTranslation();
  const { hideFooter, hideCloseButton, hideBackButton, data, showSkipButton } =
    step;
  const percent = ((index + 1) / size) * 100;
  const whiteLabelJRStepValue = useReactiveVar(whiteLabelJRStep);
  const whiteLabelValidJRStepsValue = useReactiveVar(whiteLabelValidJRSteps);
  const hideNextButton = data?.hideNextButton ?? false;

  const handleCloseClick: React.MouseEventHandler = () => {
    resetWhiteLabelJR();
  };
  const handleBackClick: React.MouseEventHandler = () => {
    whiteLabelJRStep(whiteLabelJRStepValue - 1);
  };

  const handlePrimaryClick: React.MouseEventHandler = () => {
    if (whiteLabelJRStepValue === 2) {
      (
        document.querySelector("#save-project") as HTMLButtonElement | null
      )?.click();
      return;
    }
    whiteLabelJRStep(whiteLabelJRStepValue + 1);
  };

  const width = step.data?.tooltipWidth || "350px";

  const isStep0Valid = whiteLabelValidJRStepsValue.step0 || index !== 0;

  const customContent =
    index === 5 && step.data?.customContent
      ? step.data.customContent[whiteLabelValidJRStepsValue.step5] ?? null
      : null;

  return (
    <div
      {...tooltipProps}
      className="bg-white rounded-4 overflow-hidden"
      style={{ width }}
    >
      <ProgressBar variant="success" now={percent} style={{ height: "8px" }} />
      <div className="p-3">
        <div className="d-flex justify-content-between">
          <div className="text-dark">{customContent || step.content}</div>
          {!hideCloseButton && (
            <XLg className="cursor-pointer" onClick={handleCloseClick} />
          )}
        </div>
        {!hideFooter && (
          <>
            <hr className="border border-2 border-top border-secondary" />
            <div
              className={`d-flex align-items-center ${
                hideBackButton
                  ? "justify-content-end"
                  : "justify-content-between"
              }`}
            >
              {!hideBackButton && (
                <Button
                  variant="outline-info"
                  onClick={handleBackClick}
                  className="fw-normal px-4"
                  size="sm"
                >
                  {t("secondStep.back")}
                </Button>
              )}
              {!hideNextButton && (
                <Button
                  variant="success"
                  className="px-4"
                  onClick={handlePrimaryClick}
                  disabled={!isStep0Valid}
                  size="sm"
                >
                  {t("firstStep.next")}
                </Button>
              )}
              {showSkipButton && (
                <Button
                  {...skipProps}
                  variant="link"
                  className="text-success"
                  size="sm"
                >
                  {t("whiteLabelSteps.Skip")}
                </Button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
